import React from 'react'
import { Div } from 'konsys-ui'
import _ from 'lodash'
import { RadioGroup } from './utils'
import { Divider } from './styled'

export const ServiceCategory = ({
  margin, data, services: checkedStatus, setServices,
}) => (
  <Div>
    <Divider margin={margin} orientation="left">{data.categoryName}</Divider>
    <RadioGroup
      radioName={data.id}
      value={data.services.map(v => ({
        radioId: v.id,
        value: v.id,
        text: v.serviceName,
        label: v.description,
        checked: _.find(checkedStatus, { id: data.id }).checked === v.id,
        price: v.price,
        isMinimum: v.isMinimum,
      }))}
      isCheckbox={data.services.length === 1}
      onChange={value => setServices(value)}
      // onRemove={(value) => {
      //   console.log(data.id)
      //   if (data.id === 1) {
      //     setServices(value === '2' && null)
      //   } else setServices(value === '5' && null)
      // }}
    />
  </Div>
)

export const AdditionalServiceCategory = ({
  data, additionalServices: checkedStatus, setAdditionalServices,
}) => (
  <Div>
    <Divider orientation="left">{data.type}</Divider>
    <RadioGroup
      radioName={data.id}
      value={data.services.map(v => (
        {
          radioId: v.id,
          value: v.id,
          text: v.name,
          label: v.description,
          checked: _.find(checkedStatus, { id: data.id }).checked === v.id,
          price: v.price,
          isMinimum: v.isMinimum,
        }
      ))}
      onChange={value => setAdditionalServices(value)}
    />
  </Div>
)


export default ServiceCategory



// WEBPACK FOOTER //
// ./src/pages/reserve/service-categories.jsx